import React, { Fragment } from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useLessonAssignment from 'state/providers/LessonAssignmentProvider';
import { StepThreeLessonActivities } from './StepThreeLessonActivities';
import { HwtButton } from 'components/@common/Buttons/HwtButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-regular-svg-icons';
import { translate } from 'translations/translator';
import CommonTranslationVariant from 'translations/variants/common';
const getTranslation = key => translate('lessonAssignment', key);
const translateCommon = (key: CommonTranslationVariant) => translate('common', key);

const LessonAssignmentStepThree: React.FC<any> = () => {
  const [{ lessonAssignmentState }, { stepperDispatch }] = useLessonAssignment();

  const handleEditClassesAndStudents = () => {
    stepperDispatch.setActiveStep(2);
  };

  const classes = useStyles()();
  return (
    <Paper style={{ display: 'flex', justifyContent: 'center' }}>
      <Container className={classes.outerLessonContainer}>
        <Box
          display="flex"
          justifyContent="center"
          style={{ flexDirection: 'column', alignItems: 'center', margin: '30px 0' }}
        >
          <Typography variant="h4">{getTranslation('reviewAndAssign')}</Typography>
          <Typography variant="caption" style={{ fontWeight: 300 }}>
            {getTranslation('classesAndStudentsDetails')}
          </Typography>
        </Box>
        <StepThreeLessonActivities />

        <Typography variant="h6" style={{ margin: '32px 0' }}>
          2. {getTranslation('classesAndStudents')}
        </Typography>
        <Container
          className={classes.lessonContainer}
          style={{ padding: '32px', marginBottom: '32px' }}
        >
          {lessonAssignmentState.studentsAndClassrooms.map((x, idx) => (
            <Fragment key={`classroom-container-section-${idx}`}>
              <Box display="flex" justifyContent="space-between">
                <Typography key={`classroom-section-${idx}`} variant="h6">
                  {x.label}
                </Typography>
                <HwtButton
                  onClick={handleEditClassesAndStudents}
                  variant="outlined"
                  style={{ width: '150px' }}
                >
                  <FontAwesomeIcon icon={faPencil} size="sm" style={{ marginRight: '10px' }} />
                  {translateCommon(CommonTranslationVariant.edit)}
                </HwtButton>
              </Box>
              {x.students ? (
                x.students.map((s, sIdx) => (
                  <Typography key={`student-label-${sIdx}`} variant="body2">
                    - {s.label}
                  </Typography>
                ))
              ) : (
                <Typography key={`all-students-${idx}`} variant="body2">
                  - {getTranslation('allStudents')}
                </Typography>
              )}
            </Fragment>
          ))}
        </Container>
      </Container>
    </Paper>
  );
};
const adjustment = 241;
const useStyles = () =>
  makeStyles(() => ({
    outerLessonContainer: {
      display: 'flex !important',
      minHeight: `calc(100vh - ${adjustment}px)`,
      flex: 1,
      flexDirection: 'column',
      margin: '15px 55px',
      alignSelf: 'center',
      width: '82vw !important',
      maxWidth: '1356px',
      borderRadius: '5px',
      boxShadow:
        '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
    },
    lessonContainer: {
      border: '1px solid #DBDBDB',
      borderRadius: '5px',
      marginBottom: '10px'
    },
    lessonTitle: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      margin: '30px 0px'
    }
  }));

export default LessonAssignmentStepThree;
